import { useState } from 'react';
import '../QuizType2/QuizType2.scss';
import Column from '../QuizType2/Column/Column';
import QuestionCount from '../QuestionCount/QuestionCount';
import { DragDropContext } from '@hello-pangea/dnd';

import { setNewStateForQuizType3 } from '../quizSlice';

const QuizType3 = (props) => {
  
//const [stateDataStatusResult, setStateDataStatusResult] = useState(false);
 //const [stateAnswerStatus2Version, setStateAnswerStatus2Version] = useState(false);

 const [stateDataStatus2VersionResult, setStateDataStatus2VersionResult] = useState(false);
 
  const {dispatch} = props;
  
// FIND DATA  BY QUESTION ID
const questionId = props.quizRedux.questionIdForDB;

const  findQuestionById = (questionId) => {
  console.log(questionId);
    const data = props.quizRedux.initialDataForQuizType3;
    console.log(data);
    const index = data.findIndex(item => item.id === Number(questionId));
    

  console.log(index);
  return index;
};
const indexOfQuestion = findQuestionById(questionId);
console.log(indexOfQuestion);





  const initialData3Version = props.quizRedux.initialDataForQuizType3[indexOfQuestion];
  console.log(initialData3Version);
    //ON CLICK ANSWER DND2
  const onAnswerDND2 = () => {
    console.log('Start check result DND2');

      // SET STATUS IF QUEST COMPLETE
     // setStateAnswerStatus2Version(true);
    
    const arr1 = initialData3Version.columns['column-1'].taskIds;
    const arr2 = initialData3Version.columns['column-1'].taskRightIds;

    const sameLength = arr1.length === arr2.length; //IF ARRAYS HAVE DIFFERENT LENGTH
    let sameValues = false;

    if (sameLength) {
      sameValues = arr1.every(element => arr2.includes(element)); // IF HAVE DIF VOLUMES
      
    }
    console.log(sameLength);
    console.log(sameValues);

  // SET RESULT INDICATOR
  let resultIndicator;

    if (sameLength && sameValues) {
    //console.log(result);
      console.log('ARRAY EQUEL!!!');
      resultIndicator = '100';
      //setStateDataStatusResult(true);
    } else {
      console.log('ARRAY not EQUEL!!!');
      resultIndicator = '0';
      //setStateDataStatusResult(false);
    }
   
    // SET RESULT
    props.onAnswerSelected(999, resultIndicator);

  };
//NEXT QUESTION
const nextQuestion = () => {
            let style;
          
           if (props.quizRedux.selectedItem != null) {
                style = ''
            } else {
                style = 'disabled'
            }
 
           
            return (
                <div>
                    <button onClick={props.nextQuestion.bind(this, props.quizRedux.dataQuizQuestions.length !== (props.quizRedux.counterQuestion +1) ? props.quizRedux.dataQuizQuestions[props.quizRedux.counterQuestion+1].sort_quest : null)}  disabled={style}>Следующий</button>
                </div>
            )

    }

  // ON DRAG END 2 VERSION 3 column
  const onDragEnd2Version = (result) => {
    const {destination, source, draggableId} = result;
    if (!destination) {
      return;
    }
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    const start= initialData3Version.columns[source.droppableId];
    const finish= initialData3Version.columns[destination.droppableId];

    const newTasksId = Array.from(start.taskIds);
    newTasksId.splice(source.index, 1);
    newTasksId.splice(destination.index, 0 , draggableId);

    if (start === finish) {
      const newColumn = {
        ...start,
        taskIds: newTasksId,
      }
    
      const  newState = {
        ...initialData3Version,
        columns: {
          ...initialData3Version.columns,
          [newColumn.id]: newColumn
        },
      }
      console.log('new state before dispatch');
      
      dispatch(setNewStateForQuizType3(newState));

      return;

    }
    
    //MOVING FROM ONE TO ANATHER LIST
    const  startTaskIds = Array.from(start.taskIds);
    startTaskIds.splice(source.index, 1);
    const newStart = {
      ...start,
      taskIds: startTaskIds,
    };

    const  finishTaskIds = Array.from(finish.taskIds);
    finishTaskIds.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finish,
      taskIds: finishTaskIds,
    }

    const  newState = {
      ...initialData3Version,
      columns: {
        ...initialData3Version.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish,
      },
    }
    console.log('new state before dispatch');
    console.log(initialData3Version);
    dispatch(setNewStateForQuizType3(newState));



  };
  // RENDER COLUMN 2 VERSION
  const renderDND2 =() => {

    console.log('start render DND');
    console.log(initialData3Version.columnOrder);

    return (
      <div>
        <div className="Quiz-header">
      
          <QuestionCount 
              counter={props.quizRedux.questionId} 
              total={props.quizRedux.questionLength}  
          />
                          
        </div>
      
        <DragDropContext onDragEnd={onDragEnd2Version}>
          <div className="container">
            <p className='text-main'>{initialData3Version.text}</p>
            { 

                initialData3Version.columnOrder.map((columnId, index) => {
                  const column = initialData3Version.columns[columnId];
                  console.log(column);
                  const tasks = column.taskIds.map((taskId) => initialData3Version.tasks[taskId]);
                  //const title = '2. choose several items'
                  return <Column key={column.id} column={column} tasks={tasks} 
                  styleAnswer={props.quizRedux.styleAnswer}
                  isSelected={props.quizRedux.selectedItem}
                  sortQuestion={props.sortQuestion} 
                  index={index}
                  />
                } )
            }
          </div>
          </DragDropContext>
          <button onClick={onAnswerDND2} disabled={props.isSelected} >Ответить</button>
      </div>

  )};
  return (
        <div className="Quiz">

          {renderDND2()}
          {nextQuestion()}
            
            
    
        </div>
      );
}
  export default QuizType3;